export const useOnboardingTourStore = defineStore('onboardingTourStore', () => {
  const isActive = ref(false)
  return {
    isActive
  }
})
